import { GraphQLError } from 'graphql';
import { useState } from 'react';

type FunctionType = (...args: unknown[]) => unknown;

export function useErrorBoundary(): [
	GraphQLError | undefined,
	<F extends FunctionType>(fn: F) => F,
	() => void,
] {
	const [error, setError] = useState(undefined);
	return [
		error,
		<F extends FunctionType>(fn: F): F => {
			return (async (...args: unknown[]) => {
				setError(undefined);
				try {
					return await fn(...args);
				} catch (error) {
					if (!error.graphQLErrors) {
						throw error;
					}

					setError(
						error.graphQLErrors[0] || {
							extensions: {
								error: {
									key: 'common.errors.offline',
								},
							},
						},
					);
				}
			}) as unknown as F;
		},
		() => setError(undefined),
	];
}
